const phoneSimple = (value) => {
  return /^(\+|)[0-9]*$/.test(value?.replace(/ /g, '')) ? '' : 'Ongeldig phone formaat';
};

const phoneValidators = {
  phoneSimple
};

export default phoneValidators;
